import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import { CreatorProfileSize } from './CreatorProfile'

import Image from 'components/Common/Image'
import PaletteSheet from 'components/Luxkit/PaletteSheet'
import UserAvatar from 'tripPlanner/Tripkit/Share/UserAvatar/UserAvatar'

export const CREATOR_THUMBNAIL_DIMENSIONS: Record<CreatorProfileSize, number> =
  {
    large: 64,
    medium: 48,
    small: 24,
  }

export const CREATOR_THUMBNAIL_LE_LOGO_DIMENSIONS: Record<
  CreatorProfileSize,
  number
> = {
  large: 24,
  medium: 20,
  small: 12,
}

const Container = styled(PaletteSheet)`
  position: relative;
  flex-shrink: 0;

  &.size-small {
    --dimension: ${rem(CREATOR_THUMBNAIL_DIMENSIONS.small)};
    --le-logo-dim: ${rem(CREATOR_THUMBNAIL_LE_LOGO_DIMENSIONS.small)};
    width: var(--dimension);
    height: var(--dimension);
  }

  &.size-medium {
    --dimension: ${rem(CREATOR_THUMBNAIL_DIMENSIONS.medium)};
    --le-logo-dim: ${rem(CREATOR_THUMBNAIL_LE_LOGO_DIMENSIONS.medium)};
    width: var(--dimension);
    height: var(--dimension);
  }

  &.size-large {
    --dimension: ${rem(CREATOR_THUMBNAIL_DIMENSIONS.large)};
    --le-logo-dim: ${rem(CREATOR_THUMBNAIL_LE_LOGO_DIMENSIONS.large)};
    width: var(--dimension);
    height: var(--dimension);
  }

  picture {
    width: 100%;
    height: 100%;
  }

  img {
    position: absolute;
    overflow: hidden;
    border-radius: ${(props) => props.theme.borderRadius.round};
    object-position: center;
    object-fit: fill;
    width: 100%;
    height: 100%;
  }
`

interface Props {
  size: CreatorProfileSize
  imgId?: string
}

function CreatorThumbnail({ size, imgId }: Props) {
  return (
    <Container paletteType="default" className={`size-${size}`}>
      {imgId && (
        <Image
          id={imgId}
          width={CREATOR_THUMBNAIL_DIMENSIONS[size]}
          height={CREATOR_THUMBNAIL_DIMENSIONS[size]}
          dpr={2}
          alt="Creator thumbnail"
        />
      )}
      {!imgId && <UserAvatar variant="primary" size={size}></UserAvatar>}
    </Container>
  )
}

export default React.memo(CreatorThumbnail)
